import { useState, useEffect, useCallback, useRef } from 'react';
 import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Multiselect from 'multiselect-react-dropdown';
import Select from 'react-select';
import { toast } from "react-toastify";
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import * as leadActions from "../../actions/leadActions";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as beatPlanActions from "../../actions/beatPlanActions";
import * as campaignsActions from "../../actions/campaignsActions";
import Loader from "../../components/Loader";
import * as masterAction from "../../actions/masterAction";

import AccessDenied from '../common/AccessDenied';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const AddEditBeatPlan = (props) => {
    const { id } = useParams();
    const location = useLocation();
    const { actions, usersData } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();
    const [allUsers, setAllUsers] = useState([]);

    const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
    const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);
    const [permissions, setPermissions] = useState([]);

    const [getAllChildsData, setAllChildsData] = useState([]);
    const [allVisitStatusData, setAllVisitStatusData] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);

    const [allBeatPlans, setAllBeatPlans] = useState([]);
    const [allReminderBeatPlans, setAllReminderBeatPlans] = useState([]);
    const [beatPlanId, setBeatPlanId] = useState('');
    const [showBeatPlanDetails, setShowBeatPlanDetails] = useState(false);
    const [selecteduser, setSelectedUser] = useState('');
    const [typeOfActivityUserId, setTypeOfActivityUserId] = useState('');
    const [selectedOutcome, setSelectedOutcome] = useState('');
    const [preloaderStatus, setPreloaderStatus] = useState(false);
    const [leadPlaceholder, setLeadPlaceholder] = useState('Select Lead');
    const [agreementNo, setAgreementNo] = useState("");
    const [isFound, setIsFound] = useState(false);
    const [selectedType, setSelectedType] = useState("");
    const [selectedBucket, setSelectedBucket] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [visitTypeValue, setVisitTypeValue] = useState("");
    const [scheduledTimeValue, setScheduledTimeValue] = useState("");
    const [reminderBeatPlanId, setReminderBeatPlanId] = useState("");
    const [reminderBeatPlanAction, setReminderBeatPlanAction] = useState("");
    const [allDealers, setAllDealers] = useState([]);
    const [isStartEndDayStatus, setIsStartEndDayStatus] = useState(false);

     const [latVal, setLatVal] = useState('');
      const [longVal, setLongVal] = useState('');

    const [formValues, setFormValues] = useState({
        agreement_no: '',
        assigned_user: '',
        company_name: '',
        sub_dealer_name:'',
        mobile: '',
        scheduled_time: '',
        contact_name: '',
        visit_type: '',
        remark: '',
        address: '',
        latitude: '',
        longitude: '',
        visit_status: '',
        search_lead_id: '',
        lead_id: '',
        oem_usage: '',
        oem: '',
        lead_type_id: '',
        customOem: '',
        bucket_type: '',
        bucket_value: '',
        feedback_option:'',
        credit_risk:'',
        average_km_run_per_month:'',
        next_follow_up_date:'',
    });

    // search LeadName, LeadMobile, LeadId***********************************************************
    const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [getAllChildsData1, setAllChildsData1] = useState([]);
    const [getAllLeadListData, setAllLeadListData] = useState([]);
    const [selectedLeadId, setSelectedLeadId] = useState([]);
    const [numbersArray, setNumbersArray] = useState([]);
    // const [oemOtherOption, SetoemOtherOption] = useState([]);
    const isSelected = true;

    const [allOemUsage, setAllOemUsage] = useState([]);
    const [allOem, setAllOem] = useState([]);
    const [leadTypeId, setleadTypeId] = useState([]);
    // const singleSelect ={false};
    // search LeadName, LeadMobile, LeadId***********************************************************

    const handleOutCome = () => {
        const params = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(params);
        const response = actions.getLoggedinUserChildBeat(requestData, false);
        response.then((result) => {
            response.then((result) => {
                if (result.data) {
                    const results = result.data;
                    setAllChildsData1(results);
                    setAllLeadListData(results);
                }
            }).catch((error) => {
            });
        })
    }



    const handleOemChange = (e) => {
        const selectedOem = e.target.value;
        console.log("OEM CUSTOM ", e.target)
        setFormValues((prevState) => ({
            ...prevState,
            oem: selectedOem,
            customOem: selectedOem === '10' ? prevState.customOem : ''
        }));
    };

    const handleCustomOemChange = (e) => {
        const customValue = e.target.value;
        setFormValues((prevState) => ({
            ...prevState,
            customOem: customValue
        }));
    };





    // start Bucket functionality

    const handleHardBucketToggle = () => {
        setFormValues((prev) => ({
            ...prev,
            bucket_type: "hard",
            bucket_value: "",
        }));
    };

    const handleSoftBucketToggle = () => {
        setFormValues((prev) => ({
            ...prev,
            bucket_type: "soft",
            bucket_value: "",
        }));
    };

    const handleBucketSelection = (e) => {
        setFormValues((prev) => ({
            ...prev,
            bucket_value: e.target.value,
        }));
    };


    const handleOutComeLeadType = () => {
        const params = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(params);
        const response = actions.leadStatusDataAllDropdown(requestData, false);
        response.then((result) => {
            response.then((result) => {
                if (result.data) {
                    console.log("sdsds", result.data);
                    //     setleadTypeId(results);
                    //     // setAllLeadListData(results);
                    const filteredResults = result.data.filter(option =>
                        ['Hot', 'Warm', 'Cold'].includes(option.lead_status)
                    );
                    console.log("filteredResults", filteredResults);
                    setleadTypeId(filteredResults);
                }
            }).catch((error) => {
            });
        })
    }


    useEffect(() => {
        handleOutCome();
        handleOutComeLeadType();

        if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
        
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;
                        setLatVal(latitude);
                        setLongVal(longitude);
                        
                    }, (error) => {
                        toast.error('Error getting location:', error, {
                            position: "top-right",
                        });
                    });
                } else {
                    toast.error("Google location is not supported by this browser.", {
                        position: "top-right",
                    });
                }
    }, []);

    // Common Master Dropdown Start
    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getOemUsage(requestData, false);
        response.then((result) => {
            //   console.log("Promise resolved -  campaignData:", result);
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.oem_usage_name.localeCompare(b.oem_usage_name)
                );
                setAllOemUsage(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  campaignData :", error); 
        });

    }, [setAllOemUsage]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getOem(requestData, false);
        response.then((result) => {
            //   console.log("Promise resolved -  campaignData:", result);
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const filteredResultArr = resultArr.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.oem_name.localeCompare(b.oem_name)
                );
                setAllOem(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  campaignData :", error); 
        });

    }, [setAllOem]);


    // Common Master Dropdown End.

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const beatPlanPermissions = permissionsData.find(permission => permission.module_name === 'Beat Plan');
                const hasAddPermissions = beatPlanPermissions?.add_permission;
                const hasEditPermissions = beatPlanPermissions?.edit_permission;

                setAddModulePermissionStatus(hasAddPermissions);
                setEditModulePermissionStatus(hasEditPermissions);
                setUserHasPermission(id !== undefined ? hasEditPermissions : hasAddPermissions);
            }
        }).catch((error) => {
            console.error("Promise rejected -  lead list:", error);
        });
    }, [setPermissions, setUserHasPermission]);

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);

        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

    const checkLogout = () => {
        const authToken = localStorage.getItem('authToken');
        const logInTimestamp = localStorage.getItem('logInTimestamp');

        if (logInTimestamp !== null) {
            const loginTimestamp = parseInt(logInTimestamp, 10);
            const currentTime = Math.floor(Date.now() / 1000);
            const timeElapsed = currentTime - loginTimestamp;
            const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

            if (timeElapsed >= autoLogoutTimeInSecod) {
                const params = { 'login_token': authToken };
                const requestData = encryptData(params);
                const response = actions.userLogout(requestData);
                response.then((result) => {
                    if (result.data.success === 1) {
                        const data = {};
                        actions.loadUserAuth(false);
                        actions.loginDataSuccess(data);
                        localStorage.setItem("authToken", '');
                        localStorage.setItem("logInTimestamp", '');
                        navigate("/login");
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    useEffect(() => {
        checkLogout();
    });

    const fetchBeatPlan = useCallback(() => {
        setShowBeatPlanDetails(false);
        if (id !== undefined && !showBeatPlanDetails) {
            const decodedId = atob(id);
            setBeatPlanId(decodedId);
            const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'beat_plan_id': decodedId };
            const requestData = encryptData(obj);
            const response = actions.getBeatPlanData(requestData, false);
            response.then((result) => {
                console.log("Result1", result)
                if (result.data.success === 1) {
                    setShowBeatPlanDetails(true);
                    const beatPlanInfo = result.data.data.beat_plan_data;
                    console.log("beatPlanIno", beatPlanInfo[0])

                    const initialFormValues = {
                        assigned_user: beatPlanInfo[0].assigned_user,
                        company_name: beatPlanInfo[0].company_name,
                        sub_dealer_name: beatPlanInfo[0].sub_dealer_name,
                        mobile: beatPlanInfo[0].mobile,
                        scheduled_time: beatPlanInfo[0].scheduled_time,
                        contact_name: beatPlanInfo[0].contact_name,
                        visit_type: beatPlanInfo[0].visit_type,
                        remark: beatPlanInfo[0].remarks,
                        address: beatPlanInfo[0].address,
                        latitude: beatPlanInfo[0].latitude,
                        longitude: beatPlanInfo[0].longitude,
                        visit_status: beatPlanInfo[0].visit_status,
                        lead_id: beatPlanInfo[0].id,
                        oem_usage: beatPlanInfo[0].oem_usage,
                        oem: beatPlanInfo[0].oem,
                        lead_type_id: beatPlanInfo[0].lead_type_id,
                        customOem: beatPlanInfo[0].customOem,
                        agreement_no: beatPlanInfo[0].agreement_no,
                        bucket_value: beatPlanInfo[0].bucket_value,
                        bucket_type: beatPlanInfo[0].bucket_type,
                        feedback_option: beatPlanInfo[0].feedback_option,
                        credit_risk: beatPlanInfo[0].credit_risk,
                        average_km_run_per_month: beatPlanInfo[0].average_km_run_per_month,
                        next_follow_up_date: beatPlanInfo[0].next_follow_up_date

                    };
                    setFormValues(initialFormValues);
                    if(beatPlanInfo[0]?.visitTypeName.toLowerCase() === 'start day' || beatPlanInfo[0]?.visitTypeName.toLowerCase() === 'end day'){
                        setIsStartEndDayStatus(true); 
                        
                    }   
                   // alert(beatPlanInfo[0].agreement_no);
                    setAgreementNo(beatPlanInfo[0].agreement_no);
                    setVisitTypeValue(beatPlanInfo[0].visitTypeName);                    
                    setSelectedUser(beatPlanInfo[0].assigned_user);
                    handleAssignedUser({ target: { value: beatPlanInfo[0].assigned_user } });
                    selectedLeadId(initialFormValues?.lead_id); 
                   
                    // setSelectedOutcome(beatPlanInfo[0].final_outcome_id);
                    // handleOutCome({target: { value: beatPlanInfo[0].final_outcome_id}});
                }
            }).catch((error) => {
                //  console.error("Promise rejected -  getBeatPlanData data :", error);
            });
        }

        if (id === undefined) {
            const initialFormValues = {
                assigned_user: '',
                company_name: '',
                sub_dealer_name:'',
                mobile: '',
                scheduled_time: '',
                contact_name: '',
                visit_type: '',
                remark: '',
                address: '',
                latitude: '',
                longitude: '',
                visit_status: '',
                lead_id: '',
                oem_usage: '',
                oem: '',
                lead_type_id: '',
                customOem: '',
                bucket_type: '',
                bucket_value: '',
                feedback_option:'',
                credit_risk:'',
                average_km_run_per_month:'',
                next_follow_up_date:'',
            };
            setFormValues(initialFormValues);
            setSelectedUser('');
            setSelectedOutcome('');
            setAllBeatPlans([]);
            setAllReminderBeatPlans([]);
            setVisitTypeValue('');
            setIsStartEndDayStatus(false);
                    
        }
    }, [id, setValue, setShowBeatPlanDetails, setFormValues, setSelectedUser, setSelectedOutcome]);


    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getLoggedinUserChild(requestData, false);

        response.then((result) => {
            if (result.data.success === 1) {
                const results = result.data.data.data;
                setAllChildsData(results);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });
    }, [setAllChildsData]);

    // useEffect(() => {
    //     const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    //     const requestData = encryptData(obj);
    //     const response = actions.campaignData(requestData, false);
    //     response.then((result) => {
    //         console.log("result", result)
    //         if (result.data.success === 1) {
    //             const results = result.data.data.data;
    //             const resultArr = Object.keys(results).map((key) => results[key]);
    //             const filteredResultArr = resultArr.filter((item) => item.status === "1");
    //             const sortedResultArr = filteredResultArr.sort((a, b) =>
    //                 a.campaign_name.localeCompare(b.campaign_name)
    //             );
    //             setAllCampaigns(sortedResultArr);
    //         }
    //     }).catch((error) => {
    //         //  console.error("Promise rejected -  campaignData :", error); 
    //     });

    // }, [setAllCampaigns]);



    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.campaignData(requestData, false);
        response.then((result) => {
            if (result.data.success === 1 && result.data.data && result.data.data.data) {
                const results = result.data.data.data;
                const specificCampaignNames = [
                    "Direct Marketing(Combing & Demo)",
                    "Dealership Campaigns",
                    "Hub Campagins",
                    "Collection Visit",
                    "File Signing",
                    "FI Activity",
                    "Dealership Visit",
                    "CGC Visit",
                    "Truck Junction",
                    "Vehicle Inspection",
                    "Start Day",
                    "End Day"
                ];
                const normalizedCampaignNames = specificCampaignNames.map(name => name.toLowerCase().trim());
                const filteredResultArr = Object.keys(results)
                    .map((key) => results[key])
                    .filter((item) =>
                        item.status === "1" &&
                        normalizedCampaignNames.includes(item.campaign_name.toLowerCase().trim())
                    )
                    .map((item) => ({
                        id: item.id,
                        campaign_name: item.campaign_name
                    }));
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.campaign_name.localeCompare(b.campaign_name)
                );
                setAllCampaigns(sortedResultArr);
            }
        }).catch((error) => {
            console.error("Error fetching campaigns:", error);
        });
    }, []);

    useEffect(() => { 
             const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'lead_details'};
                const requestDataMasters = encryptData(objMasters);
                const responseMasters = actions.masterAllData(requestDataMasters, false);
                responseMasters.then((result) => {
                    // console.log("Promise resolved -  master profile data:", result); 
        
                     if (result.data.success === 1) {
                        const results = result.data.data;
                        const dealerArrData = results?.all_dealers || [];
                        setAllDealers(dealerArrData); 
          
                    }
                }).catch((error) => {
                   // console.log("000000000000000000000 error  = ",error)
                });
          }, [ ]);



    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getVisitStatusData(requestData, false);
        response.then((result) => {
            if (result.data.success === 1) {
                const results = result.data.data.data;
                const resultArr = Object.keys(results).filter((key) => results[key].status === "1").map((key) => results[key]);
                setAllVisitStatusData(resultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected - getVisitStatusData: ", error); 
        });
    }, [setAllVisitStatusData]);

    // const onSubmit = (data) => {
    //     console.log("submitData", data)
    //     // const assignLeadId = JSON.stringify(selectedLeadId);
    //     if (selecteduser.trim() === '') {
    //         toast.error("Assigned to is required.", {
    //             position: "top-right",
    //         });
    //     }
    //     else if (formValues.mobile.trim() === '') {
    //         toast.error("Phone Number is required.", {
    //             position: "top-right",
    //         });
    //     } else if (formValues.scheduled_time.trim() === '') {
    //         toast.error("Scheduled Time is required.", {
    //             position: "top-right",
    //         });
    //     } else if (formValues.visit_type.trim() === '') {
    //         toast.error("Visit Type is required.", {
    //             position: "top-right",
    //         });
    //     } else if (formValues.address.trim() === '') {
    //         toast.error("Address is required.", {
    //             position: "top-right",
    //         });
    //     } else if (formValues.oem.trim() === ''){
    //         toast.error("OEM to is required.", {
    //             position: "top-right",
    //         });
    //     }
    //     else {
    //         setPreloaderStatus(true);
    //         const params = {
    //             "assigned_user": selecteduser,
    //             "company_name": formValues.company_name,
    //             "mobile": formValues.mobile,
    //             "scheduled_time": formValues.scheduled_time,
    //             "contact_name": formValues.contact_name,
    //             "visit_type": formValues.visit_type,
    //             "remark": formValues.remark,
    //             "address": formValues.address,
    //             "latitude": formValues.latitude,
    //             "longitude": formValues.longitude,
    //             "lead_id": selectedLeadId,
    //             "oem_usage": formValues.oem_usage,
    //             "oem": formValues.oem,
    //             "lead_type_id": formValues.lead_type_id,
    //         }
    //         if (beatPlanId !== undefined && beatPlanId !== '') {
    //             params.beat_plan_id = beatPlanId;
    //         }

    //         const requestData = encryptData(params);
    //         const response = actions.addEditVisitePlan(requestData);
    //         response.then((result) => {
    //             if (result.data.success === 1) {
    //                 toast.success(result.data.message, {
    //                     position: "top-right",
    //                 });
    //                 setPreloaderStatus(false);
    //                 setTimeout(() => {
    //                     navigate('/dashboard/beat-plan');
    //                 }, 1000);
    //             } else {
    //                 toast.error(result.data.message, {
    //                     position: "top-right",
    //                 });
    //                 setPreloaderStatus(false);
    //             }
    //         }).catch((error) => {
    //             toast.error(error, {
    //                 position: "top-right",
    //             });
    //             setPreloaderStatus(false);
    //         });

    //     }
    // };


    // alert(`Selected Visit_Type: ${formValues.visit_type}`);

    const onSubmit = (data) => {
        console.log("submitData", data);
        console.log("Form Values data....:", formValues);
        console.log("formValues.lead_id", formValues.lead_id);

        let latitudeVal = formValues.latitude;
        let longitudeVal = formValues.longitude;
 
        if(formValues.oem === null) {
            formValues.oem = '';
        }
        let validationStatus = true;
        if (selecteduser.trim() === '') {
            validationStatus = false;
            toast.error("Assigned to is required.", {
                position: "top-right",
            });

        } else if (formValues.visit_type.trim() === '') {
            validationStatus = false;
            toast.error("Type of Activity is required.", {
                position: "top-right",
            });
        
            
        }else if( visitTypeValue !== '' && visitTypeValue.toLowerCase() === 'collection visit' ){  

                console.log("agreement_no = ",formValues.agreement_no,);

                if (formValues.bucket_type === undefined) {
                    validationStatus = false;
                    toast.error("Please select any one Bucket.", {
                        position: "top-right",
                    });
                }else if (formValues.bucket_value === '') {
                    validationStatus = false;
                    toast.error("Please select the Bucket type.", {
                        position: "top-right",
                    });
                 
                }else if (id !== undefined && formValues.feedback_option === '') {
                    validationStatus = false;
                    toast.error("Please select the Feedback.", {
                        position: "top-right",
                    });  
                }else if (id !== undefined && formValues.credit_risk === '') {
                    validationStatus = false;
                    toast.error("Please select the Credit risk.", {
                        position: "top-right",
                    }); 
                
                }else if ( id !== undefined &&  formValues.feedback_option === 'Vehicle Odometer reading' && formValues.average_km_run_per_month === '') {
                    validationStatus = false;
                    toast.error("Average Km run per month is required.", {
                        position: "top-right",
                    });  
                }else if ( id !== undefined && (formValues.feedback_option === "Promise to pay (PTP)" || formValues.feedback_option === "Re-visit required- Customer not available") && (formValues.next_follow_up_date === '' || formValues.next_follow_up_date === '0000-00-00')) {
                    validationStatus = false;
                    toast.error("Next follow up date is required.", {
                        position: "top-right",
                    });        
                    
                }

        } 
        else if (formValues.mobile.trim() === '') {

            if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                    // skip validation 
                    
                            
            }else{
                validationStatus = false;
                toast.error("Phone Number is required.", {
                    position: "top-right",
                });
            }
           
        } else if (formValues.scheduled_time.trim() === '') { 
             if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                    // skip validation
            }else{
                validationStatus = false;
                toast.error("Scheduled Time is required.", {
                    position: "top-right",
                });
            }
       
        } else if (formValues.address.trim() === '') {

             if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                    // skip validation
            }else{
                validationStatus = false;
                toast.error("Activity Location is required.", {
                    position: "top-right",
                });
            }
        } else if (formValues.oem.trim() === '') {

             if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                    // skip validation
            }else{
                validationStatus = false;
                toast.error("OEM is required.", {
                    position: "top-right",
                });
            }
        }
        else if (formValues.oem === "10" && formValues.customOem.trim() === '') {
             if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                    // skip validation
            }else{
                validationStatus = false;
                toast.error("Custom OEM value is required when 'Other' is selected.", {
                    position: "top-right",
                });
            }
        }

        

        if(validationStatus) { 
              if( visitTypeValue !== '' && ( visitTypeValue.toLowerCase() === 'start day' )||  visitTypeValue.toLowerCase() === 'end day'){ 
                   latitudeVal =  latVal;
                   longitudeVal = longVal;            
             }

              console.log("latitudeVal = ",latitudeVal);
              console.log("longitudeVal = ",longitudeVal);
 
            // If no errors, prepare data and submit
            setPreloaderStatus(true);
            const params = {
                "assigned_user": selecteduser,
                "agreement_no": agreementNo,
                "company_name": formValues.company_name,
                "sub_dealer_name": formValues.sub_dealer_name,
                "mobile": formValues.mobile,
                "scheduled_time": formValues.scheduled_time,
                "contact_name": formValues.contact_name,
                "visit_type": formValues.visit_type,
                "remark": formValues.remark,
                "address": formValues.address,
                "latitude": latitudeVal,
                "longitude": longitudeVal,
                "lead_id": selectedLeadId,
                "oem_usage": formValues.oem_usage,
                "oem": formValues.oem,
                "lead_type_id": formValues.lead_type_id,
                "customOem": formValues.customOem,
                "bucket_type": formValues.bucket_type,
                "bucket_value": formValues.bucket_value,
                "visitTypeValue" : visitTypeValue,
                "feedback_option": formValues?.feedback_option,
                 "credit_risk": formValues?.credit_risk,
                "average_km_run_per_month": formValues?.average_km_run_per_month,
                "next_follow_up_date": formValues?.next_follow_up_date,
                "reminderBeatPlanId" : reminderBeatPlanId,
                "reminderBeatPlanAction" : reminderBeatPlanAction,
            };
 
            console.log("OnSubmit params", params)
    
            // If beatPlanId is defined, add it to params
            if (beatPlanId !== undefined && beatPlanId !== '') {
                params.beat_plan_id = beatPlanId;
            }

            const requestData = encryptData(params);
            const response = actions.addEditVisitePlan(requestData);
            response.then((result) => {
                console.log("resruki", result)
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    setTimeout(() => {
                        navigate('/dashboard/beat-plan');
                    }, 1000);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
                setPreloaderStatus(false);
            });

        }
    };

    // start search agreement number functionality


    const handleSearch = async (agreementNoVal='') => {
        try { 

            setSuggestions([]);
            const passAgreementNo = (agreementNoVal !=='') ? agreementNoVal : agreementNo;
           // alert(agreementNo);
            const params = { "AgreementNo" : passAgreementNo };
            const requestData = encryptData(params);

            const response = await actions.checkLoanNumber(requestData);
            console.log("Loan number result:", response);

            if (response.data.status === 200) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    mobile: response.data.data.CustomerNo || "",
                    contact_name: response.data.data.CustomerName || "",
                }));

                setIsFound(true);
                toast.success("Agreement number found!", { position: "top-right" });

            } else {
                console.log("Agreement Number Not Found");
                toast.error("Agreement number not found.", { position: "top-right" });
                setFormValues((prevValues) => ({
                    ...prevValues,
                    mobile: "",
                    contact_name: ""
                }));
                setIsFound(false);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong", { position: "top-right" });
            setFormValues((prevValues) => ({
                ...prevValues,
                mobile: "",
                contact_name: ""
            }));
            setIsFound(false);
        }
    };

    // end search agreement functionality


    const fetchSuggestions = async (input) => {
        if (input.length < 4) {
            setSuggestions([]);
            return;
        }

        const lastThreeDigits = input.slice(-4);
        
        
        try {
            const params = { query: lastThreeDigits };
            const requestData = encryptData(params);

            const response = await actions.getAgreementSuggestions(requestData);
            console.log("API Response:", response);

            if (response.data.status === 200) {
                setSuggestions(response.data.data);
            } else {
                setSuggestions([]);
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
            setSuggestions([]);
        }
    };



    // start reset functionality

    const handleReset = () => {
        setAgreementNo("");
        setFormValues({ mobile: "", contact_name: "" });
        setIsFound(false);
    };

    // end reset functionality 
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getTodayBeatPlanData = () => {
        const today = new Date();
        const todayFormatted = formatDate(today);
        
        console.log("Today Form Values data....:", formValues);
        console.log("Today scheduledTimeValue....:", scheduledTimeValue);

       // alert(scheduledTimeValue);
       let params = {
            start: '0',
            length: config.MAX_RECORDS,
            assigned_user: selecteduser,
            scheduled_time: scheduledTimeValue,
            visit_type: formValues.visit_type,
            today_date: todayFormatted,
            "visitTypeValue" : visitTypeValue
        };
       if(id !== undefined) {
              params = {
                start: '0',
                length: config.MAX_RECORDS,
                assigned_user: selecteduser,
                today_date: todayFormatted
            }
       } 

        console.log("Final Form params:", params);      
        const requestData = encryptData(params);      
        actions.getTodayBeatPlanData(requestData, false)
          .then((result) => {
            if (result.data.success === 1) {
              const results = result.data.data.visit_data;
              const resultArr = Object.keys(results).map((key) => results[key]);
              setAllBeatPlans(resultArr);


              const resultsReminder = result.data.data.reminders;
              const resultReminderArr = Object.keys(resultsReminder).map((key) => resultsReminder[key]);
              setAllReminderBeatPlans(resultReminderArr);
            } else {
              setAllBeatPlans([]);
              setAllReminderBeatPlans([]);
            }
          })
          .catch((error) => {
            console.error("Error fetching Beat Plan Data:", error);
          });
      };
      
      // To debounce the call, we use a ref to hold the timer across renders
      const timerRef = useRef(null);
      
      const debounceGetTodayBeatPlanData = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
      
        timerRef.current = setTimeout(() => {
          getTodayBeatPlanData();
        }, 1000);
      };
      
      const handleAssignedUser = (event) => {
        setSelectedUser(event.target.value);
        // debounceGetTodayBeatPlanData();
      };
      
      const handleTypeOfActivityUser = (event) => {
        setTypeOfActivityUserId(event.target.value);
        // debounceGetTodayBeatPlanData();
      };

    useEffect(() => {
        fetchBeatPlan();
    }, [fetchBeatPlan]);

    const getBeatPlanById = (beatPlanId, action='') => {

        setReminderBeatPlanId('');
        setReminderBeatPlanAction('');
        if(action !==''){
            setReminderBeatPlanId(beatPlanId);
            setReminderBeatPlanAction(action);
        } 

        if (beatPlanId !== undefined && beatPlanId !== '') {
            setPreloaderStatus(true);
            if(action !==''){
                setBeatPlanId('');
            }else{
                setBeatPlanId(beatPlanId);
            }
           
            const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'beat_plan_id': beatPlanId,"action" : action };
            const requestData = encryptData(obj);
            const response = actions.getBeatPlanData(requestData, false);
            response.then((result) => {
                if (result.data.success === 1) {

                    if(action ==='dismiss'){
                        getTodayBeatPlanData();
                        toast.success("Beat plan has been dismissed successfully.", {
                            position: "top-right",
                        });  
                    }else{
                        setShowBeatPlanDetails(true);
                        setPreloaderStatus(false);
                        const beatPlanInfo = result.data.data.beat_plan_data;
                        console.log("beatPlanInfo", beatPlanInfo)
                        let initialFormValues = {};
                        if(beatPlanId !=='' ){
                                initialFormValues = {
                                    assigned_user: beatPlanInfo[0].assigned_user,
                                    company_name: beatPlanInfo[0].company_name,
                                    sub_dealer_name: beatPlanInfo[0].sub_dealer_name,
                                    mobile: beatPlanInfo[0].mobile,
                                    scheduled_time: formValues.scheduled_time,
                                    contact_name: beatPlanInfo[0].contact_name,
                                    visit_type: beatPlanInfo[0].visit_type,
                                    remark: beatPlanInfo[0].remarks,
                                    address: beatPlanInfo[0].address,
                                    latitude: beatPlanInfo[0].latitude,
                                    longitude: beatPlanInfo[0].longitude,
                                    visit_status: beatPlanInfo[0].visit_status,
                                    lead_id: beatPlanInfo[0].lead_id,
                                    oem_usage: beatPlanInfo[0].oem_usage,
                                    oem: beatPlanInfo[0].oem,
                                    lead_type_id: beatPlanInfo[0].lead_type_id,
                                    customOem: beatPlanInfo[0].customOem,
                                    agreement_no: beatPlanInfo[0].agreement_no,
                                    bucket_value: beatPlanInfo[0].bucket_value,
                                    bucket_type: beatPlanInfo[0].bucket_type,
                                    feedback_option: beatPlanInfo[0].feedback_option,
                                    credit_risk: beatPlanInfo[0].credit_risk,
                                    average_km_run_per_month: beatPlanInfo[0].average_km_run_per_month
                                };
                            }else{
                            initialFormValues = {
                                assigned_user: beatPlanInfo[0].assigned_user,
                                company_name: beatPlanInfo[0].company_name,
                                sub_dealer_name: beatPlanInfo[0].sub_dealer_name,
                                mobile: beatPlanInfo[0].mobile,
                                scheduled_time: beatPlanInfo[0].scheduled_time,
                                contact_name: beatPlanInfo[0].contact_name,
                                visit_type: beatPlanInfo[0].visit_type,
                                remark: beatPlanInfo[0].remarks,
                                address: beatPlanInfo[0].address,
                                latitude: beatPlanInfo[0].latitude,
                                longitude: beatPlanInfo[0].longitude,
                                visit_status: beatPlanInfo[0].visit_status,
                                lead_id: beatPlanInfo[0].lead_id,
                                oem_usage: beatPlanInfo[0].oem_usage,
                                oem: beatPlanInfo[0].oem,
                                lead_type_id: beatPlanInfo[0].lead_type_id,
                                customOem: beatPlanInfo[0].customOem,
                                agreement_no: beatPlanInfo[0].agreement_no,
                                bucket_value: beatPlanInfo[0].bucket_value,
                                bucket_type: beatPlanInfo[0].bucket_type,
                                feedback_option: beatPlanInfo[0].feedback_option,
                                 credit_risk: beatPlanInfo[0].credit_risk,
                                average_km_run_per_month: beatPlanInfo[0].average_km_run_per_month
                            };
                        }
                        console.log("initialFormValues", initialFormValues);
                        setFormValues(initialFormValues);
                        setIsStartEndDayStatus(false);
                        if(beatPlanInfo[0]?.visitTypeName.toLowerCase() === 'start day' || beatPlanInfo[0]?.visitTypeName.toLowerCase() === 'end day'){
                            setIsStartEndDayStatus(true); 
                        } 
                        setSelectedUser(beatPlanInfo[0].assigned_user);
                        handleAssignedUser({ target: { value: beatPlanInfo[0].assigned_user } });
                        selectedLeadId(beatPlanInfo[0]?.lead_id); 
                        setAgreementNo(beatPlanInfo[0].agreement_no);
                        setVisitTypeValue(beatPlanInfo[0].visitTypeName); 

                    }
                    
                }
            }).catch((error) => {
                setPreloaderStatus(false);
            });
            setPreloaderStatus(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target; 

        setFormValues({
            ...formValues,
            [name]: value,
        }); 
         
        if(e.target.name ==='assigned_user' ){  
            handleAssignedUser(e.target.value); 
        }

        if(e.target.name ==='scheduled_time'){ 
          //  alert(e.target.value);
            setScheduledTimeValue(e.target.value); 
        }

        if(e.target.name ==='visit_type' ){ 
            setVisitTypeValue('');
            setIsStartEndDayStatus(false);
            if(e.target.value !==''){ 
                const foundCampaign = allCampaigns.find(item => item.id === e.target.value);
                if(foundCampaign?.campaign_name){
                    setVisitTypeValue(foundCampaign.campaign_name);
                } 
                if(foundCampaign?.campaign_name.toLowerCase() === 'collection visit'){
                    handleTypeOfActivityUser(e);
                }
                

                if(foundCampaign?.campaign_name.toLowerCase() === 'start day' || foundCampaign?.campaign_name.toLowerCase() === 'end day'){
                     setIsStartEndDayStatus(true);
                }
            }
        }
       // getTodayBeatPlanData(); 

        if (timerRef.current) clearTimeout(timerRef.current);
      
        timerRef.current = setTimeout(() => {
             
          getTodayBeatPlanData();
        }, 1000);
    };


    const selectAgreement = (item, agreementNoVal) => {
        setAgreementNo(agreementNoVal);
        setSuggestions([]);
        const timer = setTimeout(() => {
            handleSearch(agreementNoVal);
        }, 1000);
        return () => clearTimeout(timer);
        
    }; 

    // useEffect(() => {
       // setFormValues((prev) => ({ ...prev, agreement_no: AgreementNo }));
    //  }, [setAgreementNo]);
    
    if (!userHasPermission) {
        // Redirect or render an access denied message
        return <AccessDenied />;
    }
    return (
        <>
            <Helmet>
                <title>{showBeatPlanDetails ? "Edit Beat Plan | Ckers " : "Create Beat Plan | Ckers "}</title>
            </Helmet>

            <Container>
                <div className="row mb-4">
                    <div className="col-md-6">
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            {showBeatPlanDetails ? ((reminderBeatPlanId !=='') ? "Create Beat Plan" : "Edit Beat Plan") : "Create Beat Plan"}
                        </Typography>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div id='main-wrap'>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="assigned-to">
                                                <span>Assigned to <a style={{ color: "red" }}>*</a></span>
                                                <select id="assigned-to" className="form-select" {...register('assigned_user')} value={selecteduser} onChange={handleAssignedUser}>
                                                    <option value=''>Select User</option>
                                                    {getAllChildsData.length > 0 && getAllChildsData.map((option) => (
                                                        <option value={option.user_id}>
                                                            {option.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                            {errors.assigned_user && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>


                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="visit-type">
                                                <span>Type of Activity<a style={{ color: "red" }}>*</a></span>
                                            </label>
                                            <select
                                                id="visit-type"
                                                className="form-select"
                                                name="visit_type"
                                                value={formValues.visit_type}
                                                onChange={handleChange}
                                            >
                                                <option value=''>Select Type of Activity</option>
                                                {allCampaigns.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.campaign_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>

                                    {visitTypeValue !== '' && visitTypeValue !== undefined && visitTypeValue !== null && visitTypeValue.toLowerCase() === 'collection visit' && (
                                        <> 
                                        <div className="col-12"  >

                                        <div  className="row" style={{ borderRadius: "5px", background: "aliceblue", padding: "10px" }} >
                                            <div className="col-5">
                                                <div className="form-group">
                                                    <div className="form-check form-switch">
                                                    <label className="form-check-label " htmlFor="hard_bucket">
                                                            <b>Hard Bucket</b>
                                                        </label>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="hard_bucket"
                                                            checked={formValues.bucket_type === "hard"}
                                                            onChange={handleHardBucketToggle}
                                                        />
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-5 mt-2">
                                                <div className="form-group">
                                                    <div className="form-check form-switch">
                                                    <label className="form-check-label" htmlFor="soft_bucket">
                                                            <b>Soft Bucket</b>
                                                        </label>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="soft_bucket"
                                                            checked={formValues.bucket_type === "soft"}
                                                            onChange={handleSoftBucketToggle}
                                                        />
                                                       
                                                    </div>
                                                </div>
                                            </div>

                                            {formValues.bucket_type === "hard" && (
                                                <div className="mt-2 row">
                                                    <label>Select any one Hard Bucket : </label>
                                                    {Array.from({ length: 10 }, (_, i) => (
                                                        <div key={i} className="form-check col-4">
                                                            <input
                                                                type="radio"
                                                                className="form-check-input"
                                                                id={`bucket${i + 1}`}
                                                                name="bucket_value"
                                                                value={`Bucket${i + 1}`}
                                                                checked={formValues.bucket_value === `Bucket${i + 1}`}
                                                                onChange={handleBucketSelection}
                                                            />
                                                            <label className="form-check-label" htmlFor={`bucket${i + 1}`}>
                                                                Bucket {i + 1}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {formValues.bucket_type === "soft" && (
                                                <div className="mt-2 row">
                                                    <label>Select Soft Bucket :</label>
                                                    <div className="form-check col-4">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            id="bucketX"
                                                            name="bucket_value"
                                                            value="BucketX"
                                                            checked={formValues.bucket_value === "BucketX"}
                                                            onChange={handleBucketSelection}
                                                        />
                                                        <label className="form-check-label" htmlFor="bucketX">
                                                            Bucket X
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                            </div>

{ (id !== undefined) && (
<>    
<div className="col-12">
    <div className="form-group">
        <label htmlFor="feedback_option">
            <span>Feedback <a style={{ color: "red" }}>*</a></span>
        </label>
        <select
            id="feedback_option"
            className="form-select"
            name="feedback_option"
            value={formValues.feedback_option}
            onChange={handleChange}
        >
            <option value=''>Please Select</option>
            <option value='Vehicle Odometer reading'>Vehicle Odometer reading</option>
            <option value='Promise to pay (PTP)'>Promise to pay (PTP)</option>
            <option value='Customer refuse to pay (RTP) - Vehicle accident'>Customer refuse to pay (RTP) - Vehicle accident</option>
            <option value='Customer refuse to pay (RTP) - Customer hospitalized'>Customer refuse to pay (RTP) - Customer hospitalized</option>
            <option value='Customer refuse to pay (RTP) - Intention to not repay'>Customer refuse to pay (RTP) - Intention to not repay</option>
            <option value='Customer refuse to pay (RTP) - Recommended for vehicle repossession'>Customer refuse to pay (RTP) - Recommended for vehicle repossession</option>
            <option value='Re-visit required- Customer not available'>Re-visit required- Customer not available</option> 
            
        </select>
    </div>

</div>

{formValues.feedback_option === "Vehicle Odometer reading" && (
    <div className="col-12">
    <div className="form-group">
        <label htmlFor="Average Km run per month">
            <span>Average Km run per month <a style={{ color: "red" }}>*</a></span>
        </label>
        <input
            type="number"
            id="average_km_run_per_month"
            className="form-control"
            name="average_km_run_per_month"
            value={formValues.average_km_run_per_month}
            onChange={(e) => setFormValues({ ...formValues, average_km_run_per_month: e.target.value })}

        />
    </div>
    </div>
)}

{ (formValues.feedback_option === "Promise to pay (PTP)" || formValues.feedback_option === "Re-visit required- Customer not available") && (
   <div className="col-12">
    <div className="form-group">
        <label htmlFor="Next Follow up date">
            <span>Next Follow up date <a style={{ color: "red" }}>*</a></span>
        </label>
        <input
           type="date"
            id="next_follow_up_date"
            className="form-control"
            name="next_follow_up_date"
            value={formValues.next_follow_up_date}
            onChange={(e) => setFormValues({ ...formValues, next_follow_up_date: e.target.value })}

        />
    </div>
    </div>
)}

</>
)}                                            
        </div>
    </>
)}


 
                                    <div className={isStartEndDayStatus ? "col-md-8 hide d-none" : "col-md-8"}>
                                        <div className="form-group">
                                            <span>Loan Number (AgreementNo)</span>
                                            <div className="d-flex align-items-center gap-2">
                                                {/* <input
                                                    type="text"
                                                    className="form-control"
                                                    name="agreement_no"
                                                    value={AgreementNo}
                                                    onChange={(e) => setAgreementNo(e.target.value)}
                                                    placeholder="Enter Loan Number"
                                                /> */}
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="agreement_no"
                                                    value={agreementNo}
                                                    onChange={(e) => {
                                                        setAgreementNo(e.target.value);
                                                        fetchSuggestions(e.target.value);
                                                    }}
                                                    placeholder="Enter Last 4 Digits"
                                                />
                                                
                                                {isFound && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={handleReset}
                                                    >
                                                        Reset
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => handleSearch('')}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            { (suggestions.length>0) && (
                                            <ul className="suggestion-dropdown" style={{ listStyle: 'none', float: 'left',border: "1px solid #696c69",borderRadius: "5px",position: "absolute", background: "white", padding: "10px" }}>
                                                    {suggestions.map((item) => (
                                                        <li key={item.AgreementNo} className="suggestion-item" style={{ borderBottom: "1px solid #dddddd", padding: "10px"}}>
                                                            <button
                                                                type="button"
                                                                onClick={() => selectAgreement(item,item.AgreementNo)}
                                                                className="suggestion-button"
                                                                style={{ border: "0px",background: "none"}}
                                                            >
                                                                {item.AgreementNo} - {item.CustomerName}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}

                                        </div>
                                    </div>


                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="company-name">
                                                <span>Dealer Name</span>
                                            </label>
                                            <select
                                                id="company-name"
                                                className="form-select"
                                                name="company_name"
                                                value={formValues.company_name}
                                                onChange={handleChange}
                                            >
                                                <option value=''>Select Dealer Name</option>
                                                {allDealers.map((option) => (
                                                    <option key={option.id} value={option.name}>
                                                        {option.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>            

                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className='form-group'>
                                            <label htmlFor="sub-dealer-name">
                                                <span>Sub Dealer Name</span>  
                                                <input type='text' id='sub_dealer_name' className='form-control' {...register('sub_dealer_name')}
                                                    value={formValues.sub_dealer_name}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            {errors.sub_dealer_name && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>


                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="contact-name">
                                                <span>Contact Name</span>
                                                <input type="text" id="contact-name" className="form-control" {...register('contact_name')}
                                                    value={formValues.contact_name}
                                                    // onChange={handleChange}
                                                    onChange={(e) => setFormValues({ ...formValues, contact_name: e.target.value })}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="Phone-Number">
                                                <span>Phone Number <a style={{ color: "red" }}>*</a></span>
                                            </label>
                                            <input
                                                type="tel"
                                                id="Phone-Number"
                                                className="form-control"
                                                name="mobile"
                                                value={formValues.mobile}
                                                onChange={(e) => setFormValues({ ...formValues, mobile: e.target.value })}

                                            />
                                        </div>
                                    </div>
 

                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <span>Lead</span>
                                            <div className="text-dark">
                                                <Select
                                                    id="lead_id"
                                                    {...register('lead_id')}
                                                    value={getAllLeadListData.find(option => option.id === formValues.lead_id)}
                                                    onChange={(selectedOption) => {
                                                        setSelectedLeadId(selectedOption ? selectedOption.value : null);
                                                    }}
                                                    options={getAllLeadListData.map((option) => ({
                                                        value: option.id,
                                                        label: option.name,
                                                    }))}
                                                    placeholder="Select Lead"
                                                    isSearchable
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="scheduled-time">
                                                <span>Scheduled Time <a style={{ color: "red" }}>*</a></span>
                                                <input type="datetime-local" id="scheduled-time" className="form-control" {...register('scheduled_time')}
                                                    value={formValues.scheduled_time}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            {errors.scheduled_time && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>
                                    

 { (id !== undefined && visitTypeValue !== '' && visitTypeValue !== undefined && visitTypeValue !== null && visitTypeValue.toLowerCase() === 'collection visit' ) && (
<>    
<div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
    <div className="form-group">
        <label htmlFor="credit_risk">
            <span>Credit Risk <a style={{ color: "red" }}>*</a></span>
        </label>
        <select
            id="credit_risk"
            className="form-select"
            name="credit_risk"
            value={formValues.credit_risk}
            onChange={handleChange}
        >
            <option value=''>Please Select</option>
            <option value='Low Risk'>Low Risk</option>
            <option value='Medium Risk'>Medium Risk</option>
            <option value='High Risk'>High Risk</option>
             
            
        </select>
    </div>

</div>
</>
)}

        {allReminderBeatPlans.length > 0 && (
            
            <>
           <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
            <div className="form-group" style={{background : "#e4e7e9   " , padding : "10px"}}>
                <label htmlFor="remark">
                    <span>Reminder</span></label>

                    

                    {allReminderBeatPlans.map((beatPlan, index) => (
                        <div key={index}  className={(reminderBeatPlanAction === 'add' && reminderBeatPlanId === beatPlan.id) ? " bg-success col-12 lead-activity-item mb-2 mx-0" : (beatPlan.reminder_status === '1') ? " bg-success col-12 lead-activity-item mb-2 mx-0" : (beatPlan.reminder_status === '2') ? " text-bg-danger col-12 lead-activity-item mb-2 mx-0 " : "col-12 lead-activity-item mb-2 mx-0 pb-0"} style={{border : "1px solid #b7b1b1"}}>
                            <div className="col-12">
                                <div className='mb-0 text-black'>
                                    Next due date of Emi collection on {beatPlan.nextFollowUpDateTime} of {beatPlan.contact_name}. { beatPlan.reminder_status !== '2' &&  ("Do you want to add this Beat Plan?") }
                                    { beatPlan.reminder_status === '2' &&   (<>- <b className='text-red'>DISMISSED</b></>)}
                                </div>

                                { beatPlan.reminder_status !== '2' && (
                                <>
                                 {/*   <div className='mt-2'> 
                                    <NavLink onClick={() => getBeatPlanById(beatPlan.id,'add')}><i className="bi bi bi-plus btn btn-success" style={{ color: "black" }} /></NavLink>

                                    <NavLink onClick={() => getBeatPlanById(beatPlan.id,'dismiss')} ><i className="bi bi bi-trash btn btn-danger float-right" style={{ color: "black" }} /></NavLink>
                                    </div> */ }

                                    <div className="widget-section- mt-2">
                                    <button type="button" className="widget-button left-button col-6 text-bg-success" onClick={() => getBeatPlanById(beatPlan.id,'add')}>Add</button>
                                    <button type="button" className="widget-button right-button col-6 text-bg-danger" onClick={() => getBeatPlanById(beatPlan.id,'dismiss')}>Dismiss</button>
                                    </div>

                                </>
                                )}


                            </div>
                            
                        </div>
                    ))}
            </div>
            </div>
            </>
            
        )}

                                    <div className={isStartEndDayStatus ? "col-12" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="remark">
                                                <span>Remark</span>
                                                <textarea type="text" className="form-control" id="remark" placeholder="Type remark...." {...register('remark')}
                                                    value={formValues.remark}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="address">
                                                <span>Activity Location <a style={{ color: "red" }}>*</a></span>
                                                <textarea type="text" className="form-control" id="address" placeholder="Type location..." {...register('address')}
                                                    value={formValues.address}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            {errors.address && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="latitude">
                                                <span>
                                                    Latitude&nbsp;
                                                    <a href="https://maps.google.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }}>Map&nbsp;</a>
                                                    <a href="https://support.google.com/maps/answer/18539?hl=en" target="_blank" rel="noopener noreferrer" data-toggle="tooltip" title="" style={{ color: "red", textDecoration: 'none' }} data-original-title="How to find Latitude">?</a>
                                                    &nbsp;</span>
                                                <input type="text" id="latitude" className="form-control" {...register('latitude')}
                                                    value={formValues.latitude}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            {errors.latitude && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="longitude">
                                                <span>
                                                    Longitude&nbsp;
                                                    <a href="https://maps.google.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none' }}>Map&nbsp;</a>
                                                    <a href="https://support.google.com/maps/answer/18539?hl=en" target="_blank" rel="noopener noreferrer" data-toggle="tooltip" title="" style={{ color: "red", textDecoration: 'none' }} data-original-title="How to find Longitude">?</a>
                                                    &nbsp;</span>
                                                <input type="text" id="longitude" className="form-control" {...register('longitude')}
                                                    value={formValues.longitude}
                                                    onChange={handleChange}
                                                />
                                            </label>
                                            {errors.longitude && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>

                                    <div className="col-12 d-none" >
                                        <div className="form-group">
                                            <label htmlFor="assigned-to">
                                                <span>Visit Status</span>
                                                <select id="assigned-to" className="form-select" {...register('visit_status')}
                                                    value={formValues.visit_status}
                                                    onChange={handleChange}
                                                >
                                                    <option value=''>Select User</option>
                                                    {allVisitStatusData.length > 0 && allVisitStatusData.map((option) => (
                                                        <option value={option.id}>
                                                            {option.visit_status_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                            {errors.visit_status && <span className="required">This field is required.</span>}
                                        </div>
                                    </div>


                                    {/* Type of Vehicle start */}
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"} id="next_action_div">
                                        <div className='form-group'>
                                            <label htmlFor="prefill-template-name">
                                                {/* <span>Type Of Vehicle <a style={{ color: "red" }}>*</a></span> */}
                                                <span>Type Of Vehicle</span>
                                                <select
                                                    id='oem_usage'
                                                    name='oem_usage'
                                                    className="form-select"
                                                    {...register('oem_usage')}
                                                    value={formValues.oem_usage}
                                                    onChange={handleChange}
                                                >
                                                    {/* <option value="1">EV Vehicle Loan</option> */}
                                                    <option value=''>Select Usage</option>
                                                    {allOemUsage.length > 0 && allOemUsage.map((option) => (
                                                        <option key={option.id} value={option.id} >
                                                            {option.oem_usage_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    {/* Type of Vehicle End  */}

                                    {/* Oem Dropdown start */}
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"} id="next_action_div">
                                        <div className='form-group'>
                                            <label htmlFor="prefill-template-name">
                                                <span>OEM <a style={{ color: "red" }}>*</a></span>
                                                {/* <span>OEM</span> */}
                                                <select
                                                    id='oem'
                                                    name='oem'
                                                    className="form-select"
                                                    {...register('oem')}
                                                    value={formValues.oem}
                                                    // onChange={handleChange}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        handleOemChange(e);
                                                    }}
                                                >
                                                    {/* <option value="1">EV Vehicle Loan</option> */}
                                                    <option value=''>Select OEM</option>
                                                    {allOem.length > 0 && allOem.map((option) => (
                                                        <option key={option.id} value={option.id} >
                                                            {option.oem_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    {formValues.oem === '10' && (
                                        <div className="form-group">
                                            {/* <label htmlFor="custom_oem">Enter Custom OEM</label> */}
                                            <input
                                                type="text"
                                                id="custom_oem"
                                                name="custom_oem"
                                                className="form-control"
                                                value={formValues.customOem}
                                                onChange={handleCustomOemChange}
                                                placeholder="Enter custom OEM"
                                            />
                                        </div>
                                    )}

                                    {/* Type of Vehicle Start */}
                                    <div className={isStartEndDayStatus ? "col-12 hide d-none" : "col-12"}>
                                        <div className="form-group">
                                            <label htmlFor="final_outcome">
                                                <span>Type of Lead</span>
                                                <select id="lead_type" className="form-select" {...register('lead_type_id')}
                                                    value={formValues.lead_type_id}
                                                    onChange={handleChange}>
                                                    <option value=''>Select lead Type</option>
                                                    {leadTypeId.length > 0 && leadTypeId.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.lead_status}
                                                        </option>
                                                    ))}
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    {/* Type of Vehicle End */}
                                    {/* oem droprdown end */}

                                    <div className="col-md-12">
                                        <div className="form-group mb-2">
                                            <button className="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className={allBeatPlans.length === 0 || allBeatPlans === null ? "d-none col-md-6" : "col-md-6"}>
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            Today's Plan
                        </Typography>
                        <div id="main-wrap">
                            {allBeatPlans.length > 0 ? (
                                allBeatPlans.map((beatPlan, index) => (
                                    <div key={index} className="row lead-activity-item mb-2 mx-0">
                                        <div className="col-6 ps-0">
                                            <p className='mb-0 fw-bold'>
                                                {beatPlan.company_name}
                                            </p>
                                        </div>

                                        <div className="col-4 pe-0 text-end">
                                            <p className='mb-0'>
                                                <span
                                                    className={(beatPlan.visit_status === '2') ? "badge text-bg-success text-white" : (beatPlan.visit_status === '1') ? "badge text-bg-danger text-white" : "badge text-bg-warning text-white"}
                                                >{beatPlan.visitStatusName}</span>
                                            </p>
                                        </div>

                                        <div className="col-2 pe-0 text-end">
                                            <div className="btn-group dropstart" title="Edit">
                                                <NavLink onClick={() => getBeatPlanById(beatPlan.id)}><i className="bi bi-pen" style={{ color: "black" }} />{ }</NavLink>
                                            </div>
                                        </div>


                                    </div>
                                ))
                            ) : (
                                <p>No data available.</p>
                            )}
                        </div>
                    </div>
                </div>

                {preloaderStatus && <Loader />}


            </Container>
        </>
    );
}

function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getVisitStatusData: state.getVisitStatusData,
        getUserModuleData: state.getUserModuleData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, beatPlanActions.default, campaignsActions.default, masterAction.default ,  leadActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEditBeatPlan);